import axios, { AxiosError, AxiosResponse } from 'axios';
import { useNavigate } from 'react-router-dom';

import { HTTP_HEADERS } from 'constants/CONSTATNS';
import useUserStore from 'zustands/useUserStore';
import useModalStore from 'zustands/useAlertConfirmStore';

import useLogout from './useLogout';
import useStoreStore from 'zustands/useStoreStore';

const useApi = () => {
  const navigate = useNavigate();

  const { userToken } = useUserStore();
  const { storeSeq } = useStoreStore();
  const { setModalState } = useModalStore();
  // const { checkErrorLog } = useErrorLog();

  const logoutFn = useLogout();

  const basicHeaders: { [key: string]: string } = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const tokenHeader = {
    'x-access-token': userToken ?? '',
    STORE_SEQ: storeSeq ?? '',
  };

  // 토큰 만료 시 로그아웃 처리
  const tokenExpired = () => {
    logoutFn();
    if (userToken !== '') {
      setModalState({
        isModalShow: true,
        title: '로그인 기간 만료',
        desc: '다시 로그인을 진행해 주세요.',
      });
    }
  };
  // 선택된 사업장 값 없으면 사업장 목록으로 이동
  const unSelectedStore = () => {
    navigate('/business-establishment-choice');
  };

  const requestFn = async (headers: { [key: string]: string }, method: HTTP_HEADERS, url: string, data?: any) => {
    try {
      if (method === `get` || method === `delete`) {
        return await axios[method](url, { headers });
      } else {
        return await axios[method](url, data, { headers });
      }
    } catch (err) {
      const { response } = err as unknown as AxiosError;
      if (response?.status === 403) {
        const { data }: AxiosResponse = response;
        if (data.resultCode === 6) {
          // STORE_SEQ 잘못됨
          unSelectedStore();
        } else {
          tokenExpired();
        }
      } else {
        // 급여명세서 지급 항목 패칭 시 응답 반환
        // 저장한 급여명세서 없을 경우 404 반환 ( 정상적인 응답 )
        if (url.includes('/paystub/getPaystubPayInfo') && response?.status === 404) {
          return response;
        } else if (url.includes('/auth/updateEmpSchedule') && response?.status === 400) {
          return response;
        } else if (url.includes('/api/paystub/getPaystubCheckDate')) {
          return response;
        } else {
          setModalState({
            isModalShow: true,
            title: '통신이 원활하지 않습니다',
            desc: '고객센터로 문의해 주세요.',
          });
        }
      }
    }
  };

  const webApiNode = async (method: HTTP_HEADERS, path: string, data?: any) => {
    const testUrl = `http://192.168.0.49:10002/api`;
    const baseUrl = `https://shopsolwebserver.shop-sol.com/api`;
    return requestFn(tokenHeader, method, `${baseUrl}${path}`, data);
  };

  const webApiPhp = async (method: HTTP_HEADERS, path: string, data?: any) => {
    const testUrl = `http://192.168.0.21:10002/api`;
    const baseUrl = `https://shopsolappserver.shop-sol.com/api/v3`;
    return requestFn(basicHeaders, method, `${baseUrl}${path}`, data);
  };

  const appApiNode = async (method: HTTP_HEADERS, path: string, data?: any) => {
    const testUrl = `http://130.162.159.58:10001/api`;
    const baseUrl = `https://shopsolappserver.shop-sol.com/api`;
    return requestFn(tokenHeader, method, `${baseUrl}${path}`, data);
  };

  const commonErrorApi = async (method: HTTP_HEADERS, path: string, data?: any) => {
    const testUrl = ``;
    const baseUrl = `https://commonadminserver.shop-sol.com/api`;

    return requestFn(basicHeaders, method, `${baseUrl}${path}`, data);
  };

  return { webApiNode, webApiPhp, appApiNode, commonErrorApi };
};

export default useApi;
